import { getSystemIcon, SystemIcon } from '@helpers/icons';
import * as React from 'react';
import S from './ArticleTags.styles';
const ArticleTags = (props) => {
    if (!props.tags && !props.readTime) {
        return null;
    }
    return (React.createElement(S.Container, { "data-type": props.type },
        props.tags?.map((tag, index) => (React.createElement(S.Tag, { key: `${props.id}-tag-${index}` }, tag))),
        props.readTime && (React.createElement(S.Tag, null,
            getSystemIcon(SystemIcon.Clock),
            props.readTime))));
};
export default ArticleTags;
